import { ApiUrl } from "../ApiUrl";
import api from "../ApiService";

export const fetchGeneralSettings = async (companyId: string) => {
  const response = await api.get(
    `${ApiUrl.generalSettingsModule.common_base}${companyId}/`
  );
  return response;
};

export const updateGeneralSettings = async (
  companyId: string,
  values: object
) => {
  const response = await api.patch(
    `${ApiUrl.generalSettingsModule.common_base}${companyId}/update_general_settings/`,
    values
  );
  return response;
};

/**
 * Fetches the current menu structure for a specific company.
 *
 * @param companyID - The unique identifier of the company.
 * @returns A Promise resolving to the API response containing the menu structure.
 */
export const fetchMenuStructure = async (companyID: string) => {
  const response = await api.get(
    `${ApiUrl.menuSetting.getStructure}${companyID}/`
  );
  return response;
};

/**
 * Updates the menu structure/settings for a specific menu item.
 *
 * @param id - The ID of the menu item to update.
 * @param settingsData - An object containing the updated menu settings.
 * @returns A Promise resolving to the API response after update.
 */
export const updateMenuStructure = async (
  companyID: string,
  values: object
) => {
  const response = await api.put(
    `${ApiUrl.menuSetting.getStructure}${companyID}/`,
    values
  );
  return response;
};

export const updateListingOrder = async (
  itemIds: string[],
  contentType: string = "actions",
  year?: string
) => {
  const response = await api.patch(
    `${ApiUrl.listingOrderModule.update_order}`,
    {
      content_type: contentType,
      item_ids: itemIds,
      year}
  );
  return response;
};
